export const CONTENT_WRAPPER_ID = 'content-wrapper';
